import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=14e0d3b5"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DTInput: require('/builds/docue/website/node_modules/@docue/docue-ui/src/components/DTInput/DTInput.vue').default,IconLoader: require('/builds/docue/website/components/Icon/IconLoader.vue').default,DTButton: require('/builds/docue/website/node_modules/@docue/docue-ui/src/components/DTButton/DTButton.vue').default,AcceptTerms: require('/builds/docue/website/components/AcceptTerms.vue').default,SolidCheckIcon: require('/builds/docue/website/node_modules/@nuxt-hero-icons/solid/src/components/CheckIcon.vue').default,SolidExclamationCircleIcon: require('/builds/docue/website/node_modules/@nuxt-hero-icons/solid/src/components/ExclamationCircleIcon.vue').default})
